export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[640px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=An%20artistic%20top%20down%20composition%20of%20curated%20fashion%20items%20including%20designer%20sneakers%20a%20folded%20cashmere%20sweater%20aviator%20sunglasses%20a%20leather%20watch%20and%20a%20canvas%20tote%20bag%20arranged%20harmoniously%20on%20a%20light%20oatmeal%20linen%20texture%20with%20scattered%20eucalyptus%20leaves%20soft%20morning%20sunlight%20streaming%20diagonally%20editorial%20photography%20with%20warm%20earthy%20tones%20and%20organic%20shadows&width=1600&height=900&seq=hero-sugargoo-v2&orientation=landscape"
          alt="Sugargoo Spreadsheet curated fashion and accessories"
          title="Sugargoo Spreadsheet - Organized Shopping Resources"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/25"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 text-center lg:text-left">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-white mb-4 md:mb-5 leading-tight">
              Sugargoo Spreadsheet — The Ultimate Database For Smarter Chinese Shopping
            </h1>
            <p className="text-white/85 text-sm md:text-base max-w-xl mx-auto lg:mx-0 mb-6 md:mb-8 leading-relaxed">
              Discover organized Sugargoo spreadsheets, product finds, shopping guides, shipping information, warehouse tips, discounts, and expert reviews — all in one place.
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-3 lg:justify-start justify-center">
              <a
                href="#categories"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white font-semibold text-sm rounded-full hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-search-line"></i>
                Explore Sugargoo Spreadsheet
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-6 py-3 bg-white/95 text-foreground-900 font-semibold text-sm rounded-full hover:bg-white transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-external-link-line"></i>
                Visit Our Main Website
              </a>
            </div>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 mt-6 text-white/70 text-xs">
              <span className="flex items-center gap-1.5"><i className="ri-checkbox-circle-fill text-accent-400"></i> Updated Resources</span>
              <span className="flex items-center gap-1.5"><i className="ri-checkbox-circle-fill text-accent-400"></i> Beginner Friendly Guides</span>
              <span className="flex items-center gap-1.5"><i className="ri-checkbox-circle-fill text-accent-400"></i> Shopping Research Tools</span>
              <span className="flex items-center gap-1.5"><i className="ri-checkbox-circle-fill text-accent-400"></i> Independent Information Platform</span>
            </div>
          </div>

          <div className="flex-1 hidden lg:flex items-center justify-center">
            <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-5 md:p-6 w-full max-w-sm">
              <h3 className="text-sm font-semibold text-foreground-800 mb-4 flex items-center gap-2">
                <i className="ri-database-2-line text-primary-500"></i>
                Sugargoo Spreadsheet Database
              </h3>
              <div className="grid grid-cols-2 gap-3">
                {[
                  { name: 'Sneakers', icon: 'ri-footprint-line', color: 'bg-accent-100 text-accent-700' },
                  { name: 'Hoodies', icon: 'ri-t-shirt-line', color: 'bg-primary-100 text-primary-700' },
                  { name: 'Clothing', icon: 'ri-shirt-line', color: 'bg-secondary-100 text-secondary-700' },
                  { name: 'Accessories', icon: 'ri-star-line', color: 'bg-accent-100 text-accent-700' },
                ].map((item) => (
                  <div key={item.name} className="flex items-center gap-3 p-3 rounded-xl bg-background-50 border border-background-200">
                    <div className={`w-9 h-9 flex items-center justify-center rounded-full ${item.color}`}>
                      <i className={item.icon}></i>
                    </div>
                    <span className="text-xs font-medium text-foreground-700">{item.name}</span>
                  </div>
                ))}
              </div>
              <div className="mt-4 pt-4 border-t border-background-200">
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span>1000+ Product Guides</span>
                  <span>60+ Expert Articles</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}